import { IMAuthSDK } from '@jetprivilege/im-auth-sdk';

import config from '../config';

let authData = null;

export function checkAuth() {
  return new Promise((resolve, reject) => {
    const imAuthObj = new IMAuthSDK(
      {
        url: config.keycloakDomain,
        realm: config.realm,
        clientId: config.keycloakCId,
      },
      {},
      config.currentEnv === 'prod' || config.currentEnv === 'preprod' ? 'PROD' : 'UAT'
    );

    imAuthObj
      .checkSession(
        {},
        {
          audience: config.audience,
        }
      )
      .then(authResult => resolve(authResult))
      .catch(err => reject(err));
  });
}

export async function checkRefreshTokenExpired() {
  const current_time = new Date().getTime() / 1000 + 300;
  authData = await checkAuth()
    .then(res => res)
    .catch(err => err);

  if (authData.accessToken) {
    const token = authData.idToken;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    const jwttoken = JSON.parse(jsonPayload);
    if (current_time > jwttoken.exp) {
      /* Expired */
      checkAuth()
        .then(res => res.accessToken)
        .catch(() => null);
    }
  }

  return authData;
}
